import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Clock = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 8.00006V12.0001L14.5 14.5001M21 12.0001C21 16.9706 16.9706 21.0001 12 21.0001C7.02944 21.0001 3 16.9706 3 12.0001C3 7.0295 7.02944 3.00006 12 3.00006C16.9706 3.00006 21 7.0295 21 12.0001Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V12C11.25 12.1989 11.329 12.3897 11.4697 12.5303L13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L12.75 11.6893V8Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
